import React from 'react';
import { stringToColor } from '@fabric-ui/utils';
import { Avatar, useTheme } from '@mui/material';

interface InitialsProps {
  name: string;
  size?: 'medium' | 'small' | 'xSmall';
}

export function Initials({ name, size = 'medium' }: InitialsProps): React.JSX.Element {
  const theme = useTheme();

  return (
    <Avatar
      sx={{
        backgroundColor: stringToColor(name, theme.palette.avatarColors),
        textTransform: 'uppercase',
        fontWeight: 600,
        ...(size === 'small' ? { width: 30, height: 30, fontSize: 13 } : size === 'xSmall' ? { width: 24, height: 24, fontSize: 12 } : {}),
      }}>
      {name.split(' ')[0]?.[0]}
      {name.split(' ')[1]?.[0]}
    </Avatar>
  );
}
